export enum ToastMessageType {
  Info,
  Success,
  Warning,
  Error,
}
